/**
 * @file: 患者相关request
 */
import { RESPONSE_SUCCESS_CODE } from '@/configs/constants';
import Toast from '@/components/Toast';
import { request } from './request';
import { ApiConfigs, Response } from '../schemas/service';

const api: ApiConfigs = {
  queryPatients: {
    url: '/health/api/v1/consult/queryPatientInfosByUserId',
    method: 'GET'
  },
  savePatient: {
    url: '/health/api/v1/consult/savePatientInfo',
    method: 'POST'
  },
  deletePatient: {
    url: '/health/api/v1/consult/deletePatientInfo',
    method: 'DELETE'
  }
};

const patients = {
  async queryPatients() {
    try {
      const response: Response = await request(
        api.queryPatients,
        undefined,
        undefined,
        { hideGlobalLoading: false }
      );
      const { result } = response;
      return result;
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async savePatient(patient) {
    try {
      const response: Response = await request(api.savePatient, {}, patient, {
        needResponse: true
      });
      const { result, code, message } = response;
      if (+code === RESPONSE_SUCCESS_CODE) {
        return result;
      }
      Toast.show(message);
      return Promise.reject();
    } catch (error) {
      // console.log(error.message);
      return Promise.reject(error);
    }
  },
  async deletePatient(id) {
    try {
      const response: Response = await request(api.deletePatient, { id });
      return response;
    } catch (error) {
      // console.log(error.message);
      return Promise.reject(error);
    }
  }
};

export default patients;
